import React from 'react'
import Main from '../Category/Main'
import Main2 from '../Category/Main2'

export const Category = () => {
  return (
    <>
    <Main />
    <Main2 />
    </>
  )
}
